module.exports = __webpack_public_path__ + "img/logo-light.9d865fc8.svg";